(function () {
  'use strict';

  // Read more / Read less. Without JS the full text shows and the button stays hidden.
  function initSection(sectionEl) {
    if (!sectionEl) return;

    const text = sectionEl.querySelector('.cwc_collection-seo__text');
    const body = sectionEl.querySelector('[data-cwc-seo-body]');
    const toggle = sectionEl.querySelector('.cwc_collection-seo__toggle');
    if (!text || !body || !toggle) return;

    body.classList.add('cwc_collection-seo--collapsed');

    // Nothing hidden by the collapse → no button
    const hiddenChild = Array.prototype.some.call(text.children, function (child) {
      return window.getComputedStyle(child).display === 'none';
    });
    if (!hiddenChild) {
      body.classList.remove('cwc_collection-seo--collapsed');
      toggle.hidden = true;
      return;
    }

    toggle.hidden = false;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = toggle.dataset.more;

    if (toggle.dataset.cwcInit === 'true') return;
    toggle.dataset.cwcInit = 'true';

    toggle.addEventListener('click', function () {
      const collapsed = body.classList.toggle('cwc_collection-seo--collapsed');
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      toggle.textContent = collapsed ? toggle.dataset.more : toggle.dataset.less;
    });
  }

  function initAllSections() {
    document.querySelectorAll('.cwc_collection-seo').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.cwc_collection-seo');
    if (section) initSection(section);
  });
})();
